
import { Request } from "./request";

export interface FactoryParams {
    pn?: number;
    ps?: number;
    id?: any;
}


export function getFactoryPage(body: FactoryParams): Request {
    return {
        url: `/api/sys/org/supervise/list`,
        method: "POST",
        body,
    }
}


export function getFactoryDetail(osId: number): Request {
    return {
        url: `/api/sys/org/supervise/caution/rule`,
        method: "GET",
        params: {
            osId
        },
    }
}

// 进入系统
export function getIncludeSystem(osId: number): Request {
    return {
        url: `/api/sys/org/supervise/entrance`,
        method: "GET",
        params: {
            osId
        },
    }
}
// 首页地图点击跳转
export function getCityEntranceSystem(regionCode: string): Request {
    return {
        url: `/api/dashboard/area`,
        method: "GET",
        params: {
            regionCode
        },
    }
}
// 区域
export function getAreaList( ): Request {
    return {
        url: `/api/statistic/region/list`,
        method: "GET",
        
    }
}
